import { render, staticRenderFns } from "./ClassificationSelector.vue?vue&type=template&id=294da3c6&"
import script from "./ClassificationSelector.vue?vue&type=script&lang=js&"
export * from "./ClassificationSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VListTile } from 'vuetify/lib/components/VList';
installComponents(component, {VAutocomplete,VListTile})
